/**
 * This library helps implement a common Material UI list and items
 * Each item (aka ListEntry) has a unique ID, stores a model and can
 * be extended to add more custom properties like validators
 */
export type ListId = string;

export function generateListId(): ListId {
  return `_${Math.random().toString(36).substr(2, 9)}`;
}

export class ListEntry<T = unknown> {
  // @note do not use date-based ids
  // @see https://gist.github.com/gordonbrander/2230317
  //      https://dev.to/rahmanfadhil/how-to-generate-unique-id-in-javascript-1b13
  listId: ListId = generateListId();

  model: T;

  constructor(model: T) {
    this.model = model;
  }

  // @todo provide a deep clone to avoid direct reference changes
  // clone() {}
}
